import React, { createContext, useState, useContext } from 'react';

const DemoContext = createContext();

export function DemoProvider({ children }) {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [demoWallet, setDemoWallet] = useState(null);

  const enableDemoMode = () => {
    setIsDemoMode(true);
    setDemoWallet({
      address: '0xDemoAddress123...789',
      provider: null,
      signer: null,
    });
  };

  const disableDemoMode = () => {
    setIsDemoMode(false);
    setDemoWallet(null);
  };

  // Mock data for demo mode
  const demoData = {
    contents: [
      {
        hash: 'ipfs://QmDemo1',
        type: 'image',
        isAIGenerated: true,
        creator: '0xDemoCreator1',
        validationCount: 5,
        timestamp: new Date().toISOString(),
      },
      {
        hash: 'ipfs://QmDemo2',
        type: 'video',
        isAIGenerated: false,
        creator: '0xDemoCreator2',
        validationCount: 3,
        timestamp: new Date(Date.now() - 86400000).toISOString(),
      },
    ],
    reputation: 75,
    validations: 12,
    totalContent: 3,
  };

  return (
    <DemoContext.Provider
      value={{
        isDemoMode,
        demoWallet,
        demoData,
        enableDemoMode,
        disableDemoMode,
      }}
    >
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo() {
  return useContext(DemoContext);
}
